import Controller from '@ember/controller';

import type { SettingsEmailTemplatesShowCustomRouteModel } from './route';

// Stubbed controller to manage previewing and editing custom mailer templates
export default class SettingsEmailTemplatesShowCustomController extends Controller {
  declare model: SettingsEmailTemplatesShowCustomRouteModel;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'visitors.settings.email-templates.show.custom': SettingsEmailTemplatesShowCustomController;
  }
}
